import * as Styled from './NoResultsMessage.styled';
import { jsx as _jsx } from "react/jsx-runtime";
export const NoResultsMessage = ({
  children
}) => /*#__PURE__*/_jsx(Styled.NoResultsMessage, {
  "aria-live": "polite",
  role: "alert",
  children: children
});